<template>
    <router-link :to="'/product-categories/'+category.slug.toLowerCase()"
    class="mx-0 lg:mx-2 mb-2 lg:mb-0 relative transform hover:-translate-y-1 hover:scale-105 transition duration-300 w-full">
      <img :src="category.cover" class="rounded-md shadow-sm"/>
      <div class="flex font-serif lg:text-2xl absolute justify-center w-full bottom-1">
          {{ category.name }}
      </div>
    </router-link>

</template>

<script>
export default {
  props: ['category'],
};
</script>
